import { ChartOptions } from 'chart.js';

export const options: ChartOptions<'bar'> = {
  indexAxis: 'y' as const,
  elements: {
    bar: {
      borderWidth: 1,
      borderRadius: 4,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
  },
  scales: {
    y: {
      afterFit(scale) {
        scale.width = Math.min(scale.width, 250);
      },
      ticks: {
        font: {
          size: 11,
        },
        callback: function (value) {
          const label = this.getLabelForValue(value as number);
          const maxLength = 25;
          return label.length > maxLength ? label.substring(0, maxLength) + '…' : label;
        },
      },
    },
  },
  responsive: true,
  maintainAspectRatio: false,
};
